<template>
  <el-dialog :visible.sync="visible" class="editDialog taskDialog" title="考试统计详情" width="760px">
    <el-form class="adddevice" ref="detail" :model="detail" label-width="90px" label-suffix="：" style="margin: 0 40px 0 20px;">
      <div class="inlineBlock">
        <el-form-item prop="examName" label="考试名称">
          <p>{{ detail.examName }}</p>
        </el-form-item>
        <el-form-item prop="deptName" label="应试部门">
          <p>{{ detail.deptName }}</p>
        </el-form-item>
      </div>
      <div class="inlineBlock">
        <el-form-item prop="startTime" label="开始时间">
          <p>{{ detail.startTime }}</p>
        </el-form-item>
        <el-form-item prop="endTime" label="结束时间">
          <p>{{ detail.endTime }}</p>
        </el-form-item>
      </div>
      <div class="inlineBlock">
        <el-form-item prop="examedPeopleNum" label="已考人数">
          <p>{{ detail.examedPeopleNum }}</p>
        </el-form-item>
        <el-form-item prop="examStatusName" label="考试状态">
          <p>{{ detail.examStatusName }}</p>
        </el-form-item>
      </div>
      <div class="inlineBlock">
        <el-form-item prop="totalScore" label="考试总分">
          <p>{{ detail.totalScore }}</p>
        </el-form-item>
        <el-form-item prop="passScore" label="合格分数">
          <p>{{ detail.passScore }}</p>
        </el-form-item>
      </div>
    </el-form>
    <div class="summary">
      <div class="item">
        <div class="item-title">平均分：</div>
        <div>
          <el-progress :percentage="detail.averageScore" type="circle" :width="100" :height="100" :stroke-width="8" stroke-linecap="butt" :format="formatAverage">
          </el-progress>
        </div>
      </div>
      <div class="item">
        <div class="item-title">考试完成率：</div>
        <div>
          <el-progress :percentage="detail.examCompletedRatio" type="circle" :width="100" :height="100" :stroke-width="8" stroke-linecap="butt"></el-progress>
        </div>
      </div>
      <div class="item">
        <div class="item-title">考试通过率：</div>
        <div>
          <el-progress :percentage="detail.examPassRatio" type="circle" :width="100" :height="100" :stroke-width="8" stroke-linecap="butt"></el-progress>
        </div>
      </div>
    </div>
    <div class="testDetail">
      <div class="testTop">
        <span class="testTitle">人员考试详情</span>
      </div>
      <el-table :data="tableData" style="width: 100%;margin: 20px 0;" class="stripeTable" height="300" ref="Table">
        <el-table-column label="考试排名" prop="rank" align="center" width="120"></el-table-column>
        <el-table-column label="姓名" prop="name" align="center"></el-table-column>
        <el-table-column label="考试分数" align="center">
          <template slot-scope="scope">
            <span :class="getScore(scope.row.score)">{{ scope.row.score }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试时间" prop="examTime" align="center"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      visible: false,
      tableData: []
    }
  },
  methods: {
    checkDetail(id) {
      this.getResultDetail(id)
    },
    getResultDetail(id) {
      this.$axiosget('operation/exam/resultStatistics', {
        params: {
          id: id
        }
      }).then((res) => {
        if (res.data.status == 10000) {
          this.detail = res.data.data
          this.detail.averageScore = res.data.data.averageScore || 0
          this.tableData = res.data.data.empScoreList.map((item) => {
            return {
              score: item.score ? item.score : '--',
              rank: item.rank ? item.rank : '--',
              examTime: item.examTime ? item.examTime : '--',
              name: item.name
            }
          })
          this.visible = true
        }
      })
    },
    formatAverage(data) {
      return data + '分'
    },
    getScore(value) {
      if (value && value != '--') {
        if (value >= 60) {
          return 'pass'
        } else {
          return 'fail'
        }
      }
    }
  }
}
</script>

<style lang="less">
.taskDialog /deep/ .el-dialog__body {
  padding-top: 35px;
}
</style>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}

.inlineBlock {
  display: flex;
  align-items: center;

  .el-form-item {
    flex: 1;

    &:last-child {
      margin-left: 40px;
    }
  }
}

.summary {
  margin: 30px 30px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .item {
    display: flex;
    flex-direction: column;

    &-title {
      color: #f5f5f5;
      margin-bottom: 20px;
    }
  }

  /deep/ .el-progress__text {
    color: #f5f5f5;
  }
}

.testDetail {
  margin: 30px 30px 0 20px;

  .testTop {
    border-bottom: 1px solid #2d374d;

    .testTitle {
      color: #f5f5f5;
      padding: 0 15px 10px;
      display: inline-block;
      border-bottom: 2px solid #35b9f7;
    }
  }

  .pass {
    color: #3fa25a;
  }

  .fail {
    color: #e03b38;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exam/taskManage/resultSummary.vue